import * as React from 'react';
import {useMediaQuery, useTheme} from '@mui/material';
import Branches from './branches/Branches';
import {useAuth} from '../../context/AuthContext';
import {hasRole} from '../../utils/jwtHelper';

export default function JobTabs(): React.ReactElement {

    const [value, setValue] = React.useState(0);
    const {token} = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Check if user has adm_payroll role (not adm_branch_payroll)
    const canViewPayrollPeriods = hasRole(token, 'adm_payroll');

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            {canViewPayrollPeriods && (<Branches/>)}
        </>
    );

};